module.exports = __webpack_public_path__ + "assets/img/doc_logon.65361cb2.png";